import {store} from '../../store'
import {httpgst} from '../../main'

const state = {}

const getters = {}

const actions = {
  get ({commit, dispatch}, payload) {
    let params = {
      'vehicle_id': payload.ctx.filter.vehicle_id !== null ? payload.ctx.filter.vehicle_id : undefined,
      'project_id': payload.ctx.filter.project_id !== null ? payload.ctx.filter.project_id : undefined,
      'initial_date': payload.ctx.filter.initial_date !== null ? payload.ctx.filter.initial_date : undefined,
      'final_date': payload.ctx.filter.final_date !== null ? payload.ctx.filter.final_date : undefined,
      'type': payload.ctx.filter.type
    }
    let url = `api/fuel-request/to-xls`
    let options = {
      emulateJSON: false,
      headers: {
        'Content-type': 'application/json'
      }
    }
    payload.ctx.loading = true
    payload.ctx.loadingDownload = true
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    let newPayload = {
      params
    }
    if (payload.ctx.filter.type === 'download') {
      newPayload.responseType = 'blob'
    }
    httpgst.get(url, newPayload, options)
      .then(
        response => {
          commit(payload.ctx.filter.type === 'download' ? 'onDownloadReport' : 'onGet', {ctx: payload.ctx, response: response})
        },
        error => {
          commit('onError', { ctx: payload.ctx, error: error })
        }
      )
  }
}

const mutations = {
  onGet (state, payload) {
    let fuel = []
    const responseFuel = Object.assign({}, payload.response.data.data)
    const listFuelData = Object.getOwnPropertyNames(responseFuel)
    listFuelData.forEach(i => {
      let el = responseFuel[i]
      el = {
        ...el
      }
      fuel.push(el)
    })
    payload.ctx.fuelData = fuel
    payload.ctx.closeAll()
  },
  onDownloadReport (state, payload) {
    let date = payload.ctx.getReportDate()
    payload.ctx.forceFileDownload(payload.response.data, `ReportFuel ${payload.ctx.year} ${date}.xlsx`)
    payload.ctx.closeAll()
  },
  onError (state, payload) {
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.ctx.showNotification(payload.error.response, 'error', -1)
    }
    payload.ctx.loading = false
    payload.ctx.loadingDownload = false
    payload.ctx.loadingItems = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/reportFuel.js